import { customFetch } from '#/services/customFetch'
import type {
  SubscribeParams,
  SubscribeResponse,
} from '../types/subscribe.types'

export async function subscribeCourse(
  body: SubscribeParams,
): Promise<SubscribeResponse> {
  return customFetch<SubscribeResponse>('/student/subscriptions', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}
